import {Validation} from "@/data/Validation";
import {ProductReference} from "@/data/entities/product";

export type LoyaltyRewardDetails = {
    id: number,
    requiredPoints: number,
    active: boolean,
    orderNumber: number,
    productExternalId: string,
    product: ProductReference | null,
    creationDate: string, // OffsetDateTime
};

export type LoyaltyRewardFormValues = {
    requiredPoints: number,
    active: boolean,
    orderNumber: number,
    productId: number | null, // `null` if product doesn't exist (anymore)
};

export const loyaltyRewardFormValuesFormValidation: Validation<LoyaltyRewardFormValues> = {
    requiredPoints: {
        required: true,
    },
    active: {
        required: true,
    },
    orderNumber: {
        required: true,
    },
    productId: {
        required: true,
    },
}